import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-more-reservations',
  templateUrl: './more-reservations.component.html',
  styleUrl: './more-reservations.component.scss',
  imports: [
    PageHeaderComponent,
    QrcodeComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreReservationsComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

}
